export default __webpack_public_path__ + "static/media/logo.2926a8a9.svg";